export default __webpack_public_path__ + "static/media/icon_mask.e76e4836.svg";